// Publiczny hook akceptacji oferty - PUT /sales-crm/public-offers/{token}/accept
// BEZ OAuth (uzywa publicAxios).

import publicAxios from 'api/publicAxios';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutPublicOfferAcceptPayload {
  confirm: true;
  comment?: string;
}

const putPublicOfferAccept = (
  token: string,
  payload: IPutPublicOfferAcceptPayload
): Promise<ICommandResponseSuccess> =>
  publicAxios.put(`/sales-crm/public-offers/${token}/accept`, payload);

export const usePutPublicOfferAccept = (
  token: string,
  options?: UseMutationOptions<ICommandResponseSuccess, IError, IPutPublicOfferAcceptPayload>
) =>
  useMutation(
    (payload: IPutPublicOfferAcceptPayload) => putPublicOfferAccept(token, payload),
    options
  );
